import { VisualizatorSettings } from "./visualizator-settings";

export class FilterSettings extends VisualizatorSettings {
  constructor(settings) {
    super();
    this.name = settings.name;
    this.filter = settings.filter.copy();
  }

  copy() {
    return new FilterSettings(this);
  }
}
